/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trigger_EventInputs */

const cs_trigger_event = /** @type {(inputs: Trigger_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Událost`)
};

const en_trigger_event = /** @type {(inputs: Trigger_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Trigger_EventInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const trigger_event = /** @type {((inputs?: Trigger_EventInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trigger_EventInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trigger_event(inputs)
	return cs_trigger_event(inputs)
});